import {FooterContentList} from 'Core/models/Footer';
import {Link} from 'react-router-dom';
import React from 'react';
import {toKebabCase} from 'Shared/utilities/stringFormatHelpers';
import './Footer.sass';

export type FooterLinkProps = {
  contentMetaDataList: FooterContentList;
};

export const FooterLink = (props: FooterLinkProps) => {
  
  return (
    <>
      {props.contentMetaDataList.map((footerContentData, index) => (
        <div  className='footer__link' key={footerContentData.subTagCd}>
          {footerContentData.externalLinkFlag ? (
            <a
              href={`${footerContentData.externalURL}`}
              className='footer__link_item'
              target="_blank"
              rel="noopener noreferrer"
            >
              {footerContentData.linkTitle}
            </a>
          ) : (
            <Link
              className={'footer__link_item'}
              rel="noopener noreferrer"
              to={`/legal-notices/${toKebabCase(footerContentData.linkTitle ?? '')}?id=${
                footerContentData.contentMetadataId
              }`}
              target="_blank"
            >
              {footerContentData.linkTitle}
            </Link>
          )}
        </div>
      ))}
      <div  className={'footer_text'} >
      The Standard is a marketing name for Standard Insurance Company (Portland, Oregon), licensed in all states except New York, and The Standard Life Insurance Company of New York (White Plains, New York), licensed only in New York, and American Heritage Life Insurance Company (Jacksonville, Florida), licensed in all states except New York. Products and availability vary by state and are solely the responsibility of the applicable insurance company.
      </div>
    </>
  );
};
